import { projectImages } from "../assets";

export const Details = [
  {
    img: projectImages.V_secretum,
    name: "V Secretum",
    bio: "A secure and open sourced password manager app with encrypted storage, Google Signin, smart filters, and secure credential management.",
    stack: [
      "React Native",
      "TypeScript",
      "JavaScript",
      "Expo",
      "Nodejs",
      "Google Sigin",
      "AES Encryption",
    ],
    webLink: "https://github.com/vrushabhgawas14/V-secretum/releases",
    codeLink: "https://github.com/vrushabhgawas14/V-secretum",
    projectDate: "May 2026",
    projectType: "app",
  },
  {
    img: projectImages.littleSpace,
    name: "Little Space",
    bio: "A web app to chat with my gf when she lost her phone, so she can msg me from any device. I'll get notif of her msgs on telegram bot, indicators like typing, online, last seen, msg seen blue tick and many more.",
    stack: [
      "Nextjs",
      "TypeScript",
      "React",
      "MongoDB",
      "Tailwindcss",
    ],
    webLink: "",
    codeLink: "",
    projectDate: "Feb 2026",
    projectType: "website",
  },
  {
    img: projectImages.toDo,
    name: "To Do List App",
    bio: "Tick your Unticked ToDo's. Simple To Do List to maintain your day to day To do's.",
    stack: [
      "Nextjs",
      "TypeScript",
      "Vercel",
      "MongoDB",
      "Tailwindcss",
      "Docker",
    ],
    webLink: "https://untick-task.vercel.app/",
    codeLink: "https://github.com/vrushabhgawas14/To-Do-List-NextApp",
    projectDate: "Aug 2025",
    projectType: "website",
  },
  {
    img: projectImages.bookify,
    name: "Bookify",
    bio: "Bookify is a modern web application that converts PDFs, DOCX, and typed text into AI generated summaries and human like audio.",
    stack: [
      "React",
      "Python",
      "Fast API",
      "Groq API",
      "Ts",
      "Firebase",
      "TailwindCss",
    ],
    webLink: "https://bookify-summarization.vercel.app/",
    codeLink: "https://github.com/vrushabhgawas14/bookify",
    projectDate: "APR 2025",
    projectType: "website",
  },
  {
    img: projectImages.athawdabazaar,
    name: "Athawda Bazaar",
    bio: "Its my college event where interested students are allowed to setup stall and sell their products. I developed a offical website for this event.",
    stack: ["Next.js", "MongoDB Atlas", "Ts", "React", "TailwindCss", "Vercel"],
    webLink: "https://athawda-bazaar.vercel.app",
    codeLink: "https://github.com/vrushabhgawas14/sathayebazaar",
    projectDate: "Dec 2024",
    projectType: "website",
  },
  // {
  //   img: projectImages.travelAgency,
  //   name: "Travel in a Blink",
  //   bio: "A modern travel agency project offering seamless and fast travel experiences.",
  //   stack: ["Next.js", "React", "Ts", "Js", "TailwindCss", "Vercel"],
  //   webLink: "https://travel-in-a-blink.vercel.app",
  //   codeLink: "https://github.com/vrushabhgawas14/",
  //   projectDate: "Oct 2024",
  //   projectType: "website",
  // },
  {
    img: projectImages.portfolio,
    name: "Portfolio Website",
    bio: "Portfolio Website to showcase skills, projects and to provide personal information.",
    stack: ["React", "Ts", "TailwindCss", "Js", "Docker", "Web3Forms"],
    webLink: "https://vrushabhgawas.in/",
    codeLink: "https://github.com/vrushabhgawas14/vrushabhgawas14.github.io",
    projectDate: "Apr 2024",
    projectType: "website",
  },
  {
    img: projectImages.musicPlayer,
    name: "Music Player",
    bio: "Mini Music Player Project made with JavaScript, helps you navigate previous and next track and selecting song language.",
    stack: ["JavaScript", "Css", "HTML"],
    webLink: "https://vrushabhgawas.in/mini-music-player/",
    codeLink: "https://github.com/vrushabhgawas14/mini-music-player",
    projectDate: "Feb 2024",
    projectType: "website",
  },
  {
    img: projectImages.ticTacToe,
    name: "Tic Tac Toe Game",
    bio: "Tic Tac Toe Game developed with React. Automatically resets on Tie.",
    stack: ["JavaScript", "React", "HTML", "TailwindCss"],
    webLink: "https://vrushabhgawas.in/tic-tac-toe-react-app/",
    codeLink: "https://github.com/vrushabhgawas14/tic-tac-toe-react-app",
    projectDate: "Apr 2024",
    projectType: "website",
  },
  {
    img: projectImages.qrGenerator,
    name: "QR Generator",
    bio: "Generates QR code with Text or URL provided. You can scan the QR to get the information.",
    stack: ["JavaScript", "Css", "API", "HTML"],
    webLink: "https://vrushabhgawas.in/QR-Code-Generator/",
    codeLink: "https://github.com/vrushabhgawas14/QR-Code-Generator",
    projectDate: "Jan 2024",
    projectType: "website",
  },
];

export const arrowSVG = {
  back: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      className="ml-10 w-12 h-18 cursor-pointer opacity-80 hover:opacity-100 sm:hidden fill-slate-700 dark:fill-zinc-400"
    >
      <path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
  ),
  next: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      className="mr-10 w-12 h-18 cursor-pointer opacity-80 hover:opacity-100 sm:hidden fill-slate-700 dark:fill-zinc-400"
    >
      <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
    </svg>
  ),
};
